const highlightToken = {
	mark: "highlight",
	getAttrs: (tok) => tok.attrs,
};

export default highlightToken;
